export const INITIAL_INACTIVE_LIMIT = 4;
export const INACTIVE_PAGE_SIZE = 5;
export const ACTIVE_SECTION_KEY = 'active-seasons';
export const INACTIVE_SECTION_KEY = 'inactive-seasons';
export const SHOW_MORE_KEY = 'show-more-inactive-seasons';
export const EXPANDED_SECTION_KEYS = [ACTIVE_SECTION_KEY, INACTIVE_SECTION_KEY];
